<template>
  <div id="projectFinance">
    <ul class="numberHeadre">
      <li>
        <p class="number">{{finnaceData.contract_amount}}</p>
        <p class="headerName">合同金额</p>
      </li>
      <li>
        <p class="number">{{finnaceData.arrival}}</p>
        <p class="headerName">到账金额</p>
      </li>
      <li>
        <p class="number">{{finnaceData.balance}}</p>
        <p class="headerName">剩余金额</p>
      </li>
      <li>
        <p class="number">{{finnaceData.reimbursement}}</p>
        <p class="headerName">报销</p>
      </li>
      <li>
        <p class="number">{{finnaceData.expenditure}}</p>
        <p class="headerName">支出金额</p>
      </li>
    </ul>
    <div class="taskContainer">
      <el-tabs
        v-model="clientActive"
        @tab-click="handleClick"
        :tab-position="'left'"
        style="height: 100%;"
      >
        <!-- 6合同登记 -->
        <el-tab-pane name="6">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`合同登记(${$store.state.process.finance.sideBarData.contract.count})(${$store.state.process.finance.sideBarData.contract.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`合同登记(${$store.state.process.finance.sideBarData.contract.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.contract.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.contract.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle">合同登记</div>
            <div class="right" style="height:45px">
              <!-- <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addContractClick"
              >新增</el-button>-->
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:17%;text-align:center">交存人</div>
                <div class="headerItem" style="width:15%;text-align:center">合同金额</div>
                <div class="headerItem" style="width:33%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.finance.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  style="height:8vh;padding:8px 40px;"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckContract(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:17%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:33%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckContract(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin6==0 ? false : true"
                        @click.stop="handleRemoveContract(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 10合同用章 -->
        <el-tab-pane name="10">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`合同用章(${$store.state.process.finance.sideBarData.contract_seal.count})(${$store.state.process.finance.sideBarData.contract_seal.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`合同用章(${$store.state.process.finance.sideBarData.contract_seal.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.contract_seal.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.contract_seal.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle" style="width:70%">合同用章</div>
            <div class="right">
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectHtClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.admin.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.admin.list"
                  @click="handleCheckHt(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckHt(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.admin.isAdmin4==0 ? false : true"
                        @click.stop="handleRemoveHt(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 11合同存档 -->
        <el-tab-pane name="11">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`合同存档(${$store.state.process.finance.sideBarData.contract_archive.count})(${$store.state.process.finance.sideBarData.contract_archive.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`合同存档(${$store.state.process.finance.sideBarData.contract_archive.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.contract_archive.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.contract_archive.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle" style="width:70%">合同存档</div>
            <div class="right">
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectHtSaveClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.admin.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.admin.list"
                  @click="handleCheckHtSave(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckHtSave(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.admin.isAdmin5==0 ? false : true"
                        @click.stop="handleRemoveHtSave(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 4到账记录 -->
        <el-tab-pane name="4">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`到账记录(${$store.state.process.finance.sideBarData.arrival.count})(${$store.state.process.finance.sideBarData.arrival.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`到账记录(${$store.state.process.finance.sideBarData.arrival.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.arrival.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.arrival.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle">到账记录</div>
            <div class="right">
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectEndClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:21%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">金额</div>
                <div class="headerItem" style="width:23%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckArrival(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:21%">
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckArrival(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin4==0 ? false : true"
                        @click.stop="handleRemoveArrival(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 1报销 -->
        <el-tab-pane name="1">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`报销(${$store.state.process.finance.sideBarData.reimbursement.count})(${$store.state.process.finance.sideBarData.reimbursement.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`报销(${$store.state.process.finance.sideBarData.reimbursement.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.reimbursement.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.reimbursement.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle">报销</div>
            <div class="right">
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectFinanceClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:21%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">总金额</div>
                <div class="headerItem" style="width:23%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckReimbursement(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:21%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckReimbursement(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin1==0 ? false : true"
                        @click.stop="handleRemoveReimbursement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 9其他用章 -->
        <el-tab-pane name="9">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`其他用章(${$store.state.process.finance.sideBarData.chapter.count})(${$store.state.process.finance.sideBarData.chapter.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`其他用章(${$store.state.process.finance.sideBarData.chapter.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.chapter.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.chapter.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle" style="width:70%">其他用章</div>
            <div class="right">
              <el-button class="creat" style="background-color:#40A0F2;" @click="addOtherClick">新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.admin.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.admin.list"
                  @click="handleCheckChapter(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckChapter(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.admin.isAdmin3==0 ? false : true"
                        @click.stop="handleRemoveExpert(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 8报告用章 -->
        <el-tab-pane name="8">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`报告用章(${$store.state.process.finance.sideBarData.report.count})(${$store.state.process.finance.sideBarData.report.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`报告用章(${$store.state.process.finance.sideBarData.report.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.report.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.report.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle" style="width:70%">报告用章</div>
            <div class="right">
              <el-button class="creat" style="background-color:#40A0F2;" @click="addReportClick">新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">项目名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.admin.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  style="height:9vh;padding:10px 40px;"
                  v-for="item in $store.state.process.admin.list"
                  @click="handleCheckReport(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>

                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333;"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255);"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95);"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10);"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                      style="font-size:12px"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                    <p
                      v-if="item.top_content"
                      :title="item.top_content"
                      style="font-size:12px"
                      class="overflowDoit2row"
                    >{{item.top_content}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckReport(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.admin.isAdmin2==0 ? false : true"
                        @click.stop="handleRemoveSettlement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 12外部用章 -->
        <el-tab-pane name="12">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`外部用章(${$store.state.process.finance.sideBarData.external_seal.count})(${$store.state.process.finance.sideBarData.external_seal.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`外部用章(${$store.state.process.finance.sideBarData.external_seal.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.external_seal.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.external_seal.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle" style="width:70%">外部用章</div>
            <div class="right">
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectExtrenalClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.admin.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.admin.list"
                  @click="handleCheckExtrenal(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckExtrenal(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.admin.isAdmin3==0 ? false : true"
                        @click.stop="handleRemoveExtrenal(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 7邮寄 -->
        <el-tab-pane name="7">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`邮寄(${$store.state.process.finance.sideBarData.mail.count})(${$store.state.process.finance.sideBarData.mail.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`邮寄(${$store.state.process.finance.sideBarData.mail.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.mail.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.mail.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle" style="width:70%">邮寄</div>
            <div class="right">
              <el-button class="creat" style="background-color:#40A0F2;" @click="addMailClick">新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/物品名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.admin.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.admin.list"
                  @click="handleCheckMail(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p class="tableItemContent" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckMail(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.admin.isAdmin1==0 ? false : true"
                        @click.stop="handleRemoveMail(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 3项目专家费 -->
        <el-tab-pane name="3">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`项目专家费(${$store.state.process.finance.sideBarData.expert.count})(${$store.state.process.finance.sideBarData.expert.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`项目专家费(${$store.state.process.finance.sideBarData.expert.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.expert.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.expert.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle">项目专家费</div>
            <div class="right">
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectZhuanClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:21%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">金额</div>
                <div class="headerItem" style="width:23%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="$store.state.process.finance.list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckExpert(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:21%">
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckExpert(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin3==0 ? false : true"
                        @click.stop="handleRemoveExpert(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 2项目结算 -->
        <el-tab-pane name="2">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`项目结算(${$store.state.process.finance.sideBarData.settlement.count})(${$store.state.process.finance.sideBarData.settlement.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`项目结算(${$store.state.process.finance.sideBarData.settlement.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.settlement.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.settlement.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle">项目结算</div>
            <div class="right" style="height:45px">
              <!-- <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectClearClick"
              >新增</el-button>-->
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:21%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">金额</div>
                <div class="headerItem" style="width:23%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.finance.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckSettlement(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:21%">
                    <p v-if="item.type==1" style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                    <p
                      v-if="item.type==2"
                      style="color:#999;"
                      class="overflowDoit"
                    >{{item.business_name}}</p>
                  </div>

                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckSettlement(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin2==0 ? false : true"
                        @click.stop="handleRemoveSettlement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 5业务结算申请 -->
        <el-tab-pane name="5">
          <el-tooltip
            slot="label"
            :open-delay="500"
            effect="dark"
            :content="`业务结算(${$store.state.process.finance.sideBarData.business.count})(${$store.state.process.finance.sideBarData.business.money}元)`"
            placement="bottom-start"
          >
            <span class="tmp">
              <span>{{`业务结算(${$store.state.process.finance.sideBarData.business.count})`}}</span>
              <span
                style="color:red"
                v-if="$store.state.process.finance.sideBarData.business.money_state==1"
              >{{`${$store.state.process.finance.sideBarData.business.money}元`}}</span>
            </span>
          </el-tooltip>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="leftTitle">业务结算</div>
            <div class="right" style="height:45px">
              <!-- <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addBusinessClick"
              >新增</el-button>-->
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:21%">项目名称</div>
                <div class="headerItem" style="width:10%;text-align:center">申请人</div>
                <div class="headerItem" style="width:13%;text-align:center">金额</div>
                <div class="headerItem" style="width:23%;text-align:center">状态</div>
                <div class="headerItem" style="width:32%;text-align:center">操作</div>
              </div>
              <ul v-if="$store.state.process.finance.list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  v-for="item in $store.state.process.finance.list"
                  @click="handleCheckBusiness(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:21%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>

                  <div class="bodyItem" style="width:10%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p style="text-align:center;color:#FF3333">{{item.total}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:32%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckBusiness(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="$store.state.process.finance.isAdmin5==0 ? false : true"
                        @click.stop="handleRemoveBusiness(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 弹窗--财务 -->
    <el-dialog
      :visible.sync="$store.state.process.finance.dialogVisible"
      width="60%"
      :before-close="handleClose"
      :class="'addClientDia'"
      @close="handleClosed"
      v-dialogDrag
      modal
      :modal-append-to-body="false"
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="$store.state.process.finance.showForm==='2'"
          style="color:#128BF1;margin-right:5px"
        >{{editName}}-</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormAdd'&& $store.state.process.finance.formData.is_draft!='1'"
        >新增报销</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑报销</span>
        <span class="title-age" v-if="$store.state.process.finance.showForm==='showFormHandle'">报销详情</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormClearAdd' && $store.state.process.finance.formData.is_draft!='1' "
        >新增项目结算申请</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormClearAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑项目结算申请</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormClearHandle'"
        >项目结算申请详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormZhuanAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增项目专家申请费</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormZhuanAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑项目专家申请费</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormZhuanHandle'"
        >项目专家申请费详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormEndAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增到账记录</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormEndAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑到账记录</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormEndHandle'"
        >到账记录详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormBusinessAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增业务结算申请</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormBusinessAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑业务结算申请</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormBusinessHandle'"
        >业务结算申请详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractAdd' && $store.state.process.finance.formData.is_draft!='1'"
        >新增合同登记</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractAdd' && $store.state.process.finance.formData.is_draft=='1'"
        >编辑合同登记</span>
        <span
          class="title-age"
          v-if="$store.state.process.finance.showForm==='showFormContractHandle'"
        >合同登记详情</span>
      </div>
      <finance-details />
    </el-dialog>
    <!-- 弹窗--行政 -->
    <el-dialog
      :visible.sync="$store.state.process.admin.dialogVisible"
      width="60%"
      :before-close="handleCloseAdmin"
      :class="'addClientDia'"
      @close="handleClosedAdmin"
      v-dialogDrag
      modal
      :modal-append-to-body="false"
    >
      <div slot="title" class="header-title">
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormAdd'&& $store.state.process.admin.formData.is_draft!='1'"
        >新增邮寄</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑邮寄</span>
        <span class="title-age" v-if="$store.state.process.admin.showForm==='showFormHandle'">邮寄详情</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormClearAdd' && $store.state.process.admin.formData.is_draft!='1' "
        >新增报告用章审批</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormClearAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑报告用章审批</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormClearHandle'"
        >报告用章审批详情</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormZhuanAdd' && $store.state.process.admin.formData.is_draft!='1'"
        >新增其他用章审批</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormZhuanAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑其他用章审批</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormZhuanHandle'"
        >其他用章审批详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormHtAdd' && $store.state.process.admin.formData.is_draft!='1'"
        >新增合同用章</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormHtAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑合同用章</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormHtHandle'"
        >合同用章审批详情</span>

        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormHtSaveAdd' && $store.state.process.admin.formData.is_draft!='1'"
        >新增合同存档</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormHtSaveAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑合同存档</span>
        <span
          class="title-age"
          v-if="$store.state.process.admin.showForm==='showFormHtSaveHandle'"
        >合同存档审批详情</span>
      </div>
      <admin-details />
    </el-dialog>

    <!-- <el-dialog
      :visible.sync="$store.state.process.finance.selectVis"
      width="40%"
      key="addType"
      class="addTypeDia addFinanceDia"
      :before-close="selectVisClose"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">选择项目类型</div>
      <div class="selectBoxSettlement">
        <div class="selectItem1" @click="addProjectClearClick1">已登记项目</div>
        <div class="selectItem2" @click="addProjectClearClick2">其他项目</div>
      </div>
    </el-dialog>-->
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Draggable from 'vuedraggable'

import FinanceDetails from '../../../components/finance/FinanceDetails'
import AdminDetails from '../../../components/finance/AdminDetails'
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      finnaceData: {},
      formData: {
        is_draft: '0',
      },
      evaluation_type_list: [],
      comReload: true,
      searchDate1: '',
      searchDate2: '',
      editName: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      clientActive: '1',
      searchInfo1: '',
      projectTypeList: [],
      tiemID: null,
      timeDou: 100,
      financeIndexData: {},
      selectProjectNum: '',
      searchUserId: '',
      searchType: '',
    }
  },
  components: {
    Draggable,
    FinanceDetails,
    AdminDetails,
  },
  methods: {
    // *获取财务概览(项目)
    async getProjectFinnaceOver(val) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.project_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/finance',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.finnaceData = res.datas.list
      console.log('财务概览(项目)', this.finnaceData)
    },
    // ***获取预设审批人
    async get_preset_by_stage_code(stage_code) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/get_preset_by_stage_code',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      if (
        stage_code == 'contract' ||
        stage_code == 'business' ||
        stage_code == 'expert' ||
        stage_code == 'settlement' ||
        stage_code == 'reimbursement' ||
        stage_code == 'arrival'
      ) {
        this.$store.commit('process/finance/setList3', res.datas.list)
      } else if (
        stage_code == 'external_seal' ||
        stage_code == 'contract_archive' ||
        stage_code == 'contract_seal' ||
        stage_code == 'chapter' ||
        stage_code == 'report' ||
        stage_code == 'mail'
      ) {
        this.$store.commit('process/admin/setList3', res.datas.list)
      }
    },

    // *6.获取合同登记
    async getContractList() {
      this.$store.commit('process/finance/getContractList', this.project_id)
      console.log('合同登记列表', this.$store.state.process.finance.list)
    },
    // *6.查看合同登记详情
    async handleCheckContract(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/contract_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract')
        this.$store.commit('process/finance/getShowForm', 'showFormContractAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract')
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormContractHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *6.合同登记删除
    async handleRemoveContract(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/contract_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getContractList()
      }
    },

    // *5.获取业务结算申请列表
    async getBusinessList() {
      this.$store.commit('process/finance/getBusinessList', this.project_id)
      console.log('业务结算申请列表', this.$store.state.process.finance.list)
    },
    // *5.查看业务结算申请详情
    async handleCheckBusiness(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/business_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      let arrProject = this.formData.project_list.map((item) => {
        return item.project_id
      })
      this.formData.project_id = [...arrProject]
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('business')
        this.$store.commit('process/finance/getShowForm', 'showFormBusinessAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('business')
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormBusinessHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *5.业务结算申请删除
    async handleRemoveBusiness(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/business_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getBusinessList()
      }
    },

    // *4.查看到账记录详情
    async handleCheckArrival(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/arrival_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('arrival')
        this.$store.commit('process/finance/getShowForm', 'showFormEndAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('arrival')
        this.$store.commit('process/finance/getShowForm', 'showFormEndHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }
      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *4.到账记录删除
    async handleRemoveArrival(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/arrival_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getArrivalList()
      }
    },
    // *4.获取到账记录列表
    async getArrivalList() {
      this.$store.commit('process/finance/getArrivalList', this.project_id)
      console.log('到账记录列表', this.$store.state.process.finance.list)
    },

    // *3.查看项目专家费申请详情
    async handleCheckExpert(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/expert_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('expert')
        this.$store.commit('process/finance/getShowForm', 'showFormZhuanAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('expert')
        this.$store.commit('process/finance/getShowForm', 'showFormZhuanHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *3.项目专家费申请删除
    async handleRemoveExpert(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/expert_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getExpertList()
      }
    },
    // *3.获取项目专家费申请列表
    async getExpertList() {
      this.$store.commit('process/finance/getExpertList', this.project_id)
      console.log('项目专家费申请列表', this.$store.state.process.finance.list)
    },

    // *2.查看项目结算申请详情
    async handleCheckSettlement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/settlement_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理json
      if (this.formData.money_json) {
        this.formData.money_json = JSON.parse(this.formData.money_json)
        // 处理移动端修改没有id
        this.formData.money_json.forEach((item) => {
          if (!item.id)
            item.id = parseInt((Math.random() + 1) * Math.pow(10, 6 - 1))
        })
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('settlement')
        if (res.datas.info.type == '1') {
          this.$store.commit('process/finance/getShowForm', 'showFormClearAdd')
        }
        if (res.datas.info.type == '2') {
          this.$store.commit('process/finance/getShowForm', 'showFormClearAdd1')
        }
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('settlement')

        if (res.datas.info.type == '1') {
          this.$store.commit(
            'process/finance/getShowForm',
            'showFormClearHandle'
          )
        }
        if (res.datas.info.type == '2') {
          this.$store.commit(
            'process/finance/getShowForm',
            'showFormClearHandle1'
          )
        }
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *2.项目结算申请删除
    async handleRemoveSettlement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/settlement_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getSettlementList()
      }
    },
    // *2.获取项目结算申请列表
    async getSettlementList() {
      this.$store.commit('process/finance/getSettlementList', this.project_id)
      console.log('项目结算申请列表', this.$store.state.process.finance.list)
    },

    // *1.查看报销详情
    async handleCheckReimbursement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/reimbursement_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('reimbursement')
        this.$store.commit('process/finance/getShowForm', 'showFormAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('reimbursement')
        this.$store.commit('process/finance/getShowForm', 'showFormHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *1.报销删除
    async handleRemoveReimbursement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reimbursement_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReimbursementList()
      }
    },
    // *1.获取报销列表
    async getReimbursementList() {
      this.$store.commit(
        'process/finance/getReimbursementList',
        this.project_id
      )
    },

    // !行政Start
    // *12.查看外部用章审批详情
    async handleCheckExtrenal(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/external_seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }
      if (this.formData.total) {
        this.formData.total = parseInt(this.formData.total)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('external_seal')
        this.$store.commit('process/admin/getShowForm', 'showFormExtrenalAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('external_seal')
        this.$store.commit(
          'process/admin/getShowForm',
          'showFormExtrenalHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      console.log('conloahusdhaisudhasuid', this.formData)
      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *12.外部用章批删除
    async handleRemoveExtrenal(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/external_seal_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getExtrenalList()
      }
    },
    // *12.外部用章列表
    async getExtrenalList() {
      this.$store.commit('process/admin/getExtrenalList', this.project_id)
    },
    // *11.查看合同存档详情
    async handleCheckHtSave(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/contract_archive_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理图片
      if (this.formData.annex) {
        this.imgList = this.formData.annex
        this.detailsImgList = this.formData.annex
      }

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      console.log('其他用章审批详情', this.formData)
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_archive')
        this.$store.commit('process/admin/getShowForm', 'showFormHtSaveAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_archive')
        this.$store.commit('process/admin/getShowForm', 'showFormHtSaveHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }

      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *11.合同存档批删除
    async handleRemoveHtSave(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/contract_archive_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getHtSaveList()
      }
    },
    // *11.合同存档列表
    async getHtSaveList() {
      this.$store.commit('process/admin/getHtSaveList', this.project_id)
    },

    // *10.查看合同用章详情
    async handleCheckHt(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/contract_seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_seal')
        this.$store.commit('process/admin/getShowForm', 'showFormHtAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_seal')
        this.$store.commit('process/admin/getShowForm', 'showFormHtHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *10.合同用章批删除
    async handleRemoveHt(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/contract_seal_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getHtList()
      }
    },
    // *10.合同用章列表
    async getHtList() {
      this.$store.commit('process/admin/getHtList', this.project_id)
    },

    // *9.查看其他用章审批详情
    async handleCheckChapter(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/chapter_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('chapter')
        this.$store.commit('process/admin/getShowForm', 'showFormZhuanAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('chapter')
        this.$store.commit('process/admin/getShowForm', 'showFormZhuanHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      console.log('conloahusdhaisudhasuid', this.formData)
      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *9.其他用章审批删除
    async handleRemoveExpert(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/chapter_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getChapterList()
      }
    },
    // *9.获取其他用章审批列表
    async getChapterList() {
      this.$store.commit('process/admin/getChapterList', this.project_id)
    },

    // *8.查看报告用章审批详情
    async handleCheckReport(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/report_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      console.log('报告用章审批详情', this.formData)
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('report')
        this.$store.commit('process/admin/getShowForm', 'showFormClearAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('report')
        this.$store.commit('process/admin/getShowForm', 'showFormClearHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *8.报告用章审批删除
    async handleRemoveSettlement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/report_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReportList()
      }
    },
    // *8.获取报告用章审批列表
    async getReportList() {
      this.$store.commit('process/admin/getReportList', this.project_id)
    },

    // *7.查看邮寄详情
    async handleCheckMail(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/mail_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理图片
      if (this.formData.annex) {
        this.imgList = this.formData.annex
        this.detailsImgList = this.formData.annex
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      console.log('邮寄详情', this.formData)
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('mail')
        this.$store.commit('process/admin/getShowForm', 'showFormAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('mail')
        this.$store.commit('process/admin/getShowForm', 'showFormHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *7.邮寄删除
    async handleRemoveMail(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/mail_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getMailList()
      }
    },
    // *7.获取邮寄列表
    async getMailList() {
      this.$store.commit('process/admin/getMailList', this.project_id)
    },
    // !行政end

    // !start点击新增财务相关
    // 6.点击新增合同登记
    addContractClick() {
      const data = {
        preset_member: '',

        pay_type: '',
        is_review: '1',
        pay_review_type: '1',

        is_reg: '0',
        is_bid: '0',
        bid_money: 0,
        is_mark: '0',
        mark_json: '0',
        ontract_no: '',
        business_name: '',
        project_type: '',
        manager: '',
        paid: '',
        date_sign: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: '',
        project_id: [],
      }
      if (this.$route.query.isFromProject == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('contract')
      this.$store.commit('process/finance/getShowForm', 'showFormContractAdd')
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 5.点击新增业务结算申请
    addBusinessClick() {
      const data = {
        preset_member: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: '',
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('business')
      this.$store.commit('process/finance/getShowForm', 'showFormBusinessAdd')
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 4.点击新增到账记录
    addProjectEndClick() {
      const data = {
        preset_member: '',

        is_settle: '0',
        is_settlement: '0',
        project_list: [],
        total: '',
        date: '',
        remark: '',
        annex: '',
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('arrival')
      this.$store.commit('process/finance/getShowForm', 'showFormEndAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 3.点击新增专家申请费
    addProjectZhuanClick() {
      const data = {
        preset_member: '',

        type: '',
        total: '',
        remark: '',
        annex: '',
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('expert')
      this.$store.commit('process/finance/getShowForm', 'showFormZhuanAdd')
      this.$store.commit('process/finance/getFormData', data)
      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 2.点击新增项目结算申请按钮
    //  *(修改)点击新增项目结算选择选择新增的项目结算类型
    addProjectClearClick() {
      this.$store.commit('process/finance/getselectVis', true)
    },
    selectVisClose() {
      this.$store.commit('process/finance/getselectVis', false)
    },
    // 点击新增项目结算申请按钮(已登记项目)
    addProjectClearClick1() {
      const data = {
        preset_member: '',

        money: 0,
        is_special: '0',
        special_money: 0,
        money_json: [],
        project_list: [],
        total: '',
        remark: '',
        annex: [],
        project_id: [],
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('settlement')
      this.$store.commit('process/finance/getShowForm', 'showFormClearAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // 1.点击新增报销按钮
    addProjectFinanceClick() {
      const data = {
        preset_member: '',

        is_draft: '0',
        type: '1',
        title: '',
        destination: '',
        date: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: '',
        project_id: [],
        bill: '',
        no_bill: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('reimbursement')
      this.$store.commit('process/finance/getShowForm', 'showFormAdd')
      this.$store.commit('process/finance/getFormData', data)

      this.$store.commit('process/finance/getDialogVisible', true)
    },
    // !end点击新增财务相关

    // !srart点击行政新增
    // 12.新增外部用章
    addProjectExtrenalClick() {
      const data = {
        remark: '',
        annex: [],
        project_id: [],
        total: 0,

        seal_type: '1',
        num: 1,
        preset_member: '',
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('external_seal')
      this.$store.commit('process/admin/getShowForm', 'showFormExtrenalAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 11.新增合同存档
    addProjectHtSaveClick() {
      const data = {
        remark: '',
        preset_member: '',

        annex: '',
        project_id: [],
        business_name: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('contract_archive')
      this.$store.commit('process/admin/getShowForm', 'showFormHtSaveAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 10.新增合同用章
    addProjectHtClick() {
      const data = {
        remark: '',
        annex: '',
        project_id: [],
        preset_member: '',

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('contract_seal')
      this.$store.commit('process/admin/getShowForm', 'showFormHtAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 9.新增其他用章审批
    addOtherClick() {
      const data = {
        preset_member: '',
        remark: '',
        annex: '',
        project_id: [],
        preset_member: '',

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('chapter')
      this.$store.commit('process/admin/getShowForm', 'showFormZhuanAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 8.新增报告用章审批
    addReportClick() {
      const data = {
        remark: '',
        preset_member: '',

        annex: '',
        project_id: [],
        seal_type: '1',
        num: 1,
        business_name: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('report')
      this.$store.commit('process/admin/getShowForm', 'showFormClearAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 7.新增邮寄
    addMailClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: '',
        project_id: [],
        business_name: '',
        address: '',
        receive: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('mail')
      this.$store.commit('process/admin/getShowForm', 'showFormAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // !end点击行政新增

    handleClick(tab, event) {
      if (tab.name == '1') {
        this.getReimbursementList()
      } else if (tab.name == '2') {
        this.getSettlementList()
      } else if (tab.name == '3') {
        this.getExpertList()
      } else if (tab.name == '4') {
        this.getArrivalList()
      } else if (tab.name == '5') {
        this.getBusinessList()
      } else if (tab.name == '6') {
        this.getContractList()
      } else if (tab.name == '7') {
        this.getMailList()
      } else if (tab.name == '8') {
        this.getReportList()
      } else if (tab.name == '9') {
        this.getChapterList()
      } else if (tab.name == '10') {
        this.getHtList()
      } else if (tab.name == '11') {
        this.getHtSaveList()
      } else if (tab.name == '12') {
        this.getExtrenalList()
      }
    },
    // 财务关闭
    handleClose(done) {
      this.$store.commit('process/finance/getDialogVisible', false)
    },
    handleClosed() {
      // 清空预设审批人
      this.$store.commit('process/finance/setList3', [])
      this.$store.commit('process/finance/emptyFormData')
      this.$store.commit('process/finance/getDraftDisable', false)
      this.$store.commit('process/finance/getSideBarShow', false)
      this.$store.commit('process/finance/getContainerType', '0')
    },
    // 行政关闭
    handleCloseAdmin(done) {
      this.$store.commit('process/admin/getDialogVisible', false)
    },
    handleClosedAdmin() {
      // 清空预设审批人
      this.$store.commit('process/admin/setList3', [])
      this.$store.commit('process/admin/emptyFormData')
      this.$store.commit('process/admin/getDraftDisable', false)
      this.$store.commit('process/admin/getSideBarShow', false)
      this.$store.commit('process/admin/getContainerType', '0')
    },
    // **获取侧边栏数据
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.project_id = this.$route.query.project_id || ''
    this.project_name = this.$route.query.project_name || ''
    this.project_code = this.$route.query.project_code || ''
    this.company_name = this.$route.query.company_name || ''
    if (this.project_id)
      this.$store.commit(
        'process/finance/getFinanceSildeBarNum',
        this.project_id
      )
    this.getProjectFinnaceOver()
    this.getReimbursementList()
  },
  computed: {},
}
</script>
<style lang="less" scoped>
@import url(./financeProject.scss);
</style>
